<template>
  <v-container id="data-tables" tag="section">
    <base-material-card color="indigo" icon="mdi-content-copy" inline class="px-5 py-3">
      <template v-slot:after-heading>
        <div class="display-2 font-weight-light">Course templates</div>
      </template>

      <v-data-table
        :headers="headers"
        :items="items"
        :search.sync="search"
        :sort-by="['name', 'office']"
        :sort-desc="[false, true]"
        multi-sort
      >
        <template v-slot:top>
          <v-toolbar flat>
            <v-btn color="primary" @click="createItem">New item</v-btn>
            <v-spacer></v-spacer>
            <v-text-field
              v-model="search"
              append-icon="mdi-magnify"
              class="ml-auto"
              label="Search"
              hide-details
              single-line
              style="max-width: 250px;"
            />
          </v-toolbar>
          <v-divider class="mt-3" />
        </template>

        <template v-slot:item.actions="{ item }">
          <v-icon class="mr-2" @click="editItem(item)">mdi-lead-pencil</v-icon>
          <v-icon @click="deleteItem(item)">mdi-delete</v-icon>
        </template>
      </v-data-table>
    </base-material-card>

    <v-dialog v-if="Dialog.dialog" v-model="Dialog.dialog" persistent max-width="290">
      <v-card>
        <v-card-title class="headline">Are you sure?</v-card-title>
        <v-card-actions>
          <v-btn color="green darken-1" text @click="Dialog.dialog = false">No</v-btn>
          <v-spacer></v-spacer>
          <v-btn
            color="green darken-1"
            text
            @click="Dialog.deleteAction();Dialog.dialog = false"
          >Yes</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <div class="text-center ma-2">
      <v-snackbar v-model="Snackbar.visible" :timeout="Snackbar.timeout" :color="Snackbar.color">
        {{ Snackbar.snackbarText }}
        <v-btn dark text @click="Snackbar.visible = false">Close</v-btn>
      </v-snackbar>
    </div>
  </v-container>
</template>

<script>
import TrainingTemplate from "../../../servcies/api/training/TrainingTemplate";

export default {
  name: "TrainingTemplate",

  data: () => ({
    headers: [
      {
        text: "Description",
        value: "description"
      },
      {
        text: "Course",
        value: "courseName"
      },
      {
        sortable: false,
        text: "Actions",
        value: "actions"
      }
    ],
    items: [],
    search: undefined,
    courses: [],
    Dialog: {
      item: null,
      dialog: false,
      deleteAction: () => {}
    },
    Snackbar: {
      snackbarText: "",
      visible: false,
      timeout: 5000,
      color: "error"
    }
  }),

  created() {
    this.init();
  },

  methods: {
    editItem(item) {
      this.$router.push({ path: `templateEdit/${item.id}` });
    },

    createItem() {
      this.$router.push({ path: "templateCreate" });
    },

    deleteItem(item) {
      this.Dialog.dialog = true;
      this.Dialog.item = item;

      this.Dialog.deleteAction = () => {
        var id = item.id;
        TrainingTemplate.deleteTemplate(id)
          .then(result => {
            this.getTemplates();
          })
          .catch(err => {
            this.Snackbar.snackbarText = err;
            this.Snackbar.visible = true;
          });
      };
    },

    init() {
      this.getTemplates();
      this.getCourses();
    },
    //Get data
    getTemplates() {
      let loader = this.$loading.show();
      TrainingTemplate.getTemplates()
        .then(result => {
          this.items = result;
          loader.hide();
        })
        .catch(err => {
          this.Snackbar.snackbarText = err;
          this.Snackbar.visible = true;
          loader.hide();
        });
    },

    getCourses() {
      let loader = this.$loading.show();
      TrainingTemplate.getCourses()
        .then(result => {
          this.courses = result;
          loader.hide();
        })
        .catch(err => {
          this.Snackbar.snackbarText = err;
          this.Snackbar.visible = true;
          loader.hide();
        });
    }
  }
};
</script>
